module.exports = __webpack_public_path__ + "static/media/ico-edit.ca9c33c6.svg";